import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=2a577a1a&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=2a577a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a577a1a",
  null
  
)

export default component.exports